module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "toc-fmt-emt"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_04_TOC#_idTextAnchor001"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_05_Intro#_idTextAnchor002"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_06_Ch01#_idTextAnchor003"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("1")]), _vm._v(" Wake-Up Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_07_Ch02#_idTextAnchor005"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("2")]), _vm._v(" Sweet Intentions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_08_Ch03#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("3")]), _vm._v(" A Secret Microbial Garden")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_09_Ch04#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("4")]), _vm._v(" A Sweet Addiction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_10_Ch05#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("5")]), _vm._v(" Be Mindful of the Stress-Induced Sweet Tooth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_11_Ch06#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("6")]), _vm._v(" What Are Sugary Foods, Exactly?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_12_Ch07#_idTextAnchor013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("7")]), _vm._v(" Wheat Gut")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_13_Ch08#_idTextAnchor014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("8")]), _vm._v(" Sugar Incognito")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_14_Ch09#_idTextAnchor017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("9")]), _vm._v(" Balanced Bellies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ct"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_15_Ch10#_idTextAnchor019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc_cn"
  }, [_vm._v("10")]), _vm._v(" Tuning In to the Garden Within")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_16_Notes#_idTextAnchor022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_17_Bib#_idTextAnchor023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt-emt"
  }, [_c('span', {
    staticClass: "calibre2",
    attrs: {
      "href": "#/OEBPS/18_304_19_Aut#_idTextAnchor024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1b68eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/18_304_04_TOC.vue
// module id = 69
// module chunks = 0